import {
  DELAYED_DELIVERY,
  DELAYED_DELIVERY_WITH_NEW_DATE,
  FALLBACK_STATUS,
  GOING_TO_RECIPIENT,
  GOING_TO_RECIPIENT_WITH_RELATIVE_ETA,
  IN_LOGGI,
  IN_RECIPIENT,
  IN_SENDER,
  RECIPIENT_PICKUP,
  UNAVAILABLE_RECIPIENT,
  UNAVAILABLE_RECIPIENT_WITH_NEW_DATE
} from './status.constants';

/**
 * Status >= 100 are frontend defined
 * -> 100 to 199 are considered WARNING status
 * -> 200 to 299 are considered NEUTRAL status
 * -> 300 to 399 are considered SUCCESS status
 * -> 400 to 499 are considered ERROR status
 */
const STATUS_CODE = {
  0: 'IN_SENDER',
  3: 'WRONG_ADDRESS',
  4: 'DELIVERY_DENIED',
  6: 'UNAVAILABLE_RECIPIENT',
  7: 'DAMAGED_PACKAGE',
  8: 'INVALID_PACKAGE_DIMENSIONS',
  9: 'SUSPENDED_PACKAGE',
  10: 'ADDRESS_WITHOUT_COMPLEMENT',
  11: 'LOST_PACKAGE',
  12: 'PACKAGE_NOT_FOUND',
  13: 'STOLEN_PACKAGE',
  16: 'DELAYED_DELIVERY',
  21: 'WAITING_DEVOLUTION',
  30: 'RECIPIENT_PICKUP',
  100: 'DELAYED_DELIVERY_WITH_NEW_DATE',
  105: 'UNAVAILABLE_RECIPIENT_WITH_NEW_DATE',
  200: 'GOING_TO_RECIPIENT',
  205: 'GOING_TO_RECIPIENT_WITH_RELATIVE_ETA',
  210: 'IN_LOGGI',
  300: 'IN_RECIPIENT',
  400: 'UNAVAILABLE_CANCELED'
};

const ETA_LIMIT = 60 * 60 * 2;

const DESTINATION_NAMES = {
  LOGGI: 'LOGGI',
  RECIPIENT: 'RECIPIENT',
  SENDER: 'SENDER'
};

const { LOGGI, SENDER, RECIPIENT } = DESTINATION_NAMES;

const getErrorStatus = (error, eta) => {
  const errorStatus = STATUS_CODE[error] ? STATUS_CODE[error] : FALLBACK_STATUS;
  if (errorStatus === UNAVAILABLE_RECIPIENT && eta) {
    return UNAVAILABLE_RECIPIENT_WITH_NEW_DATE;
  }
  if (errorStatus === DELAYED_DELIVERY && eta) {
    return DELAYED_DELIVERY_WITH_NEW_DATE;
  }
  return errorStatus;
};

export default function getStatus(packageTracker) {
  const {
    currentStatus: { error, destination, inProgress },
    redispatchInfo: { trackingCode, maxPickupTime },
    eta,
    relativeEta
  } = packageTracker;

  const isRedispatchRecipientPickup =
    trackingCode !== null && maxPickupTime !== null;

  if (error) {
    return getErrorStatus(error, eta);
  }

  if (isRedispatchRecipientPickup) {
    return RECIPIENT_PICKUP;
  }

  if (destination === LOGGI) {
    return IN_LOGGI;
  }

  if (destination === SENDER) {
    return IN_SENDER;
  }

  if (destination === RECIPIENT && relativeEta && relativeEta <= ETA_LIMIT) {
    return GOING_TO_RECIPIENT_WITH_RELATIVE_ETA;
  }

  return inProgress ? GOING_TO_RECIPIENT : IN_RECIPIENT;
}
